import React, { useEffect, useState } from 'react'
import "./BoxContainer.css"
import CustomVedio from "../CustomVedio/CustomVedio"
import { Col, Container, Row } from 'react-bootstrap';
import { addAnswer } from '../../hook/AnswersCourses';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
function BoxContainer({ title, data, questions, videoPath, mainTitle, img }) {
  const dispatch = useDispatch()
  const [activeBtn, setActiveBtn] = useState(false);
  const navigate=useNavigate()
  const {id}=useParams()
    const { answerQuestion } = useSelector((state) => state);
  
useEffect(() => {

  const found = answerQuestion?.answer?.find(
    (c) => Number(c.course) === Number(id)
  );

  setActiveBtn(!!found);

}, [id, answerQuestion]);
console.log(activeBtn);

  return (
    <div className='box_container'>

      {mainTitle &&
        <p className='mt-5 title fw-bold main_title'>{mainTitle} :</p>
      }

      <div className='lesson_objectives p-4 mb-4'>

        {title &&
          <h5 className='title'>{title}</h5>
        }
        {data === "Video" ?

          <>
            <CustomVedio
              questions={questions}
              videoPath={videoPath}
            />
          </>
          : data == "activt" ?
            <Container>
              <Row>
                <p className='fw-bold fs-5'>أخترالاجابة الصحيحة :</p>
                {questions.map((item, xindex) => {

                  return (
                    <div className='mt-4'>
                      <h6>{"السؤال"}{xindex + 1}{" : "}{item?.question}</h6>
                      <ul>
                        {item.options.map((op, index) => {
                          return (
                            <li className='py-2 option_answer btn_custom'
                              style={{ display: 'block', width: '80%', margin: '10px 0', backgroundColor: '#d1d1d1ff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontFamily: "Noto Kufi Arabic", color: "#000" }}

                              onClick={() => {
                                const isCorrect = item.answer == op ? 1 : 0;

                                dispatch(addAnswer({
                                  question: xindex + 1,   // ← رقم السؤال الصحيح
                                  is_correct: isCorrect,
                                  course: id
                                }));
                                if (item?.answer == op) {

                                  alert("✅ إجابة صحيحة!");
                                  if (xindex === questions.length - 1) {
                                    setActiveBtn(true)
                                  }

                                } else {

                                  alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${item.answer}`);

                                }

                              }}
                            >{"الاجابة"}{" "}{index + 1}{" : "}{op}</li>
                          )
                        })}
                      </ul>
                    </div>
                  )
                })}
                <div className='d-flex justify-content-end mt-4 '>

                  {activeBtn ?
                    <button className="py-2 rounded text-white d-flex align-items-center justify-content-center border-0 px-4" style={{
                      background: "rgba(0, 38, 86, 1)"
                    }}
                      onClick={() => {
                        if (id >2) {
                          navigate(`/course_details/${Number(id) - 1}`)
                        } else {
                          navigate(`/`)

                        }
                      }}
                    >الانتقال الي السؤال التالي</button>

                    :
                    <button className=" bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center border-0 px-4 " disabled>الانتقال الي السؤال التالي</button>

                  }
                </div>
              </Row>
            </Container>

            :
            <>
              <Container>
                <Row>
                  <Col md={8}>

                    <p className='valu'>{data}</p>

                  </Col>
                  <Col md={4}>
                    {img &&
                      <img src={img} alt='' className='w-75 rounded' />
                    }
                  </Col>
                </Row>
              </Container>
            </>

        }

      </div>
    </div>
  )
}

export default BoxContainer